import { constants } from '@trucktrax/trucktrax-common';
import { TicketWithCurrentStatusDto } from '../types';

export enum IncomingStatusPhase {
  BeforeArrival,
  AtDestination,
  Departed,
}

/** Meaningful IM transitions when independently delivered status timestamps tie. */
export function getIncomingStatusPhase(status?: string): IncomingStatusPhase {
  switch (status) {
    case constants.STATUS_IDS.RETURNING:
    case constants.STATUS_IDS.IN_YARD:
      return IncomingStatusPhase.Departed;
    case constants.STATUS_IDS.ON_JOB:
    case constants.STATUS_IDS.UNLOAD_START:
    case constants.STATUS_IDS.UNLOADED:
      return IncomingStatusPhase.AtDestination;
    default:
      return IncomingStatusPhase.BeforeArrival;
  }
}

/**
 * Arrival is known at OnJob or beyond. Departure still counts as an arrival;
 * isIncomingTicket separately removes departed tickets from the incoming views.
 * Read only the authoritative currentStatus, never externalInfo.status.
 */
export function hasIncomingTicketArrived(ticket: TicketWithCurrentStatusDto): boolean {
  return getIncomingStatusPhase(ticket.currentStatus?.status) > IncomingStatusPhase.BeforeArrival;
}
